export default __webpack_public_path__ + "static/media/whiteAws.a39a0a0f.svg";